import {analyticsService} from '@/services/analytics/analytics-service';
import {useMemo} from 'react';

export const useAnalytics = () => {
  return useMemo(() => ({
    pageView: analyticsService.pageView.bind(analyticsService),
    trackEvent: analyticsService.trackEvent.bind(analyticsService),
  }), []);
};
